<template>
  <div>
    <div class="tab-section-active" v-if="vacationGroups.active.length > 0">
      <div class="matrix-panel">
        <div class="table-layout">
          <div class="table-head">
            <div class="table-tr">
              <div class="table-th cell-word-review">{{ __('[coach availability] Date') }}</div>
              <div class="table-th cell-duration">{{ __('Length') }}</div>
              <div class="table-th cell-patient">{{ __('Holiday substitute') }}</div>
              <div class="table-th dropdowns"></div>
            </div>
          </div>

          <div class="table-body">
            <VacationRow
              v-for="vacation in vacationGroups.active"
              :key="vacation.id"
              :vacation="vacation"
              @canceled="onCanceled"
              class="active-vacation"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="tab-section-future">
      <div class="vacation">
        <h3 :style="{ opacity: vacationGroups.future.length ? 1 : 0 }" class="tab-subtitle">{{ __('Upcoming holidays') }}</h3>

        <VButton size="sm" @onClick="showCreateForm = true" :label="__('Add a holiday')" modalTarget="modal-new-vacation" />
      </div>

      <div class="matrix-panel" v-if="vacationGroups.future.length > 0">
        <div class="table-layout">
          <div class="table-head">
            <div class="table-tr">
              <div class="table-th cell-word-review">{{ __('[coach availability] Date') }}</div>
              <div class="table-th cell-duration">{{ __('Length') }}</div>
              <div class="table-th cell-patient">{{ __('Holiday substitute') }}</div>
              <div class="table-th dropdowns"></div>
            </div>
          </div>

          <div class="table-body">
            <VacationRow
              v-for="vacation in futureVacations"
              :key="vacation.id"
              :vacation="vacation"
              @canceled="onCanceled"
              @remove="removedVacation = vacation"
              @edit="
                showEditForm = true
                editedVacation = vacation
              "
            />
          </div>
        </div>
      </div>
    </div>

    <div class="tab-section-past" v-if="vacationGroups.past.length > 0">
      <h3 class="tab-subtitle">{{ __('Past holidays') }}</h3>
      <div class="matrix-panel">
        <div class="table-layout">
          <div class="table-head">
            <div class="table-tr">
              <div class="table-th cell-word-review">{{ __('[coach availability] Date') }}</div>
              <div class="table-th cell-duration">{{ __('Length') }}</div>
              <div class="table-th cell-patient">{{ __('Holiday substitute') }}</div>
              <div class="table-th dropdowns"></div>
            </div>
          </div>

          <div class="table-body">
            <VacationRow
              v-for="vacation in pastVacations"
              :key="vacation.id"
              :vacation="vacation"
              @canceled="onCanceled"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-if="loading" class="loader-wrapper">
      <img src="/imgs/vitadio-loader.svg" alt="">
    </div>

    <div v-else-if="vacationGroups.past.length === 0 && vacationGroups.future.length === 0 && vacationGroups.active.length === 0" class="no-data">
      <figure>
        <svg-icon icon="icon-no-data"></svg-icon>
      </figure>
      <p>{{ __("No records") }}</p>
    </div>

    <VacationCreate v-if="showCreateForm" :coach="coach" @created="onVacationCreated" />
    <VacationEdit v-if="showEditForm" :coach="coach" :edited-vacation="editedVacation" @updated="onVacationEdited" />
    <VacationDelete :coach="coach" :removed-vacation="removedVacation" @canceled="onCanceled" />
  </div>
</template>

<script>
  import VacationCreate from './VacationCreate'
  import VacationEdit from './VacationEdit'
  import VacationRow from './VacationRow'
  import VacationDelete from './VacationDelete'

  export default {
    components: {
      VacationCreate,
      VacationEdit,
      VacationRow,
      VacationDelete
    },
    props: {
      coach: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        showCreateForm: false,
        showEditForm: false,
        editedVacation: null,
        removedVacation: null,
        vacationGroups: {
          active: [],
          future: [],
          past: [],
        },
        loading: true
      }
    },
    computed: {
      pastVacations() {
        return _.orderBy(this.vacationGroups.past, 'end_date', 'desc')
      },
      futureVacations() {
        return _.orderBy(this.vacationGroups.future, 'start_date')
      }
    },
    watch: {
      async '$parent.tab'(tab) {
        if (tab === 'vacation') {
          const { active, future, past } = (await this.fetch())

          if (active) {
            this.$set(this.vacationGroups, 'active', active)
          }

          if (future) {
            this.$set(this.vacationGroups, 'future', future)
          }

          if (past) {
            this.$set(this.vacationGroups, 'past', past)
          }

          this.loading = false
        }
      }
    },
    mounted() {
      $(this.$el).on('hidden.bs.modal', '#modal-edit-vacation', (e) => {
        this.showEditForm = false
        this.editedVacation = null
      })

      $(this.$el).on('hidden.bs.modal', '#modal-delete-vacation', (e) => {
        this.removedVacation = null
      })
    },
    methods: {
      fetch() {
        return axios.get(`/coaches/${this.coach.id}/vacations`).then((r) => r.data.data)
      },
      onVacationCreated(vacation) {
        this.showCreateForm = false

        this.addVacation(vacation)
      },
      onVacationEdited(vacation) {
        this.showEditForm = false

        this.vacationGroups[vacation.status] = this.vacationGroups[vacation.status]
            .map((v) => v.id === vacation.id ? vacation : v)
      },
      onCanceled(vacation) {
        this.removeVacation(vacation)
      },
      addVacation(vacation) {
        this.vacationGroups[vacation.status].push(vacation)
      },
      removeVacation(vacation) {
        this.$set(this.vacationGroups, vacation.status, this.vacationGroups[vacation.status].filter((v) => v.id !== vacation.id))
      }
    }
  }
</script>
